import { Component, Input } from '@angular/core';
import { NgIf, NgStyle } from '@angular/common';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  standalone: true,
  imports: [NgIf, NgStyle]
})
export class FooterComponent {
  @Input() backgroundColor = '#d0d0ce';
  @Input() textColor = '#000000';
  @Input() showVersion = false;
  @Input() version = '';
}
